import { LegalDocument } from "@/features/legal/components/LegalDocument";

export function PrivacyPolicyPage() {
  return <LegalDocument document="privacy" />;
}
